import React, {useState} from 'react';
import {Button, FormGroup, TextField} from '@mui/material';
import {PasswordLine, PasswordPassedLine, Val} from './passResetModal.styled';

function PasswordResetModal() {
    const [passed, setPassed] = useState(0)
    const [samePasswords, setSamePasswords] = useState(true)
    const [password, setPassword] = useState('');
    const [passwordRepeat, setPasswordRepeat] = useState('');

    const isGood = (password: string) => {
        let regex = [];
        regex.push("[A-Z]"); //Uppercase Alphabet.
        regex.push("[a-z]"); //Lowercase Alphabet.
        regex.push("[0-9]"); //Digit.
        regex.push("[$@$!%*#?&]");

        //Validate for each Regular Expression.
        let test = 0
        for (let i = 0; i < regex.length; i++) {
            if (new RegExp(regex[i]).test(password)) {
                test++
            }
        }
        setPassed(test);
        setPassword(password);
    }

    const getPasswordText = () => {
        switch (passed) {
            case 0:
                return 'Очень легкий';
            case 1:
                return 'Легкий';
            case 2:
                return 'Средний';
            case 3:
                return 'Надежный';
            case 4:
                return 'Очень надежный';
        }
    }

    const comparePasswords = (value: string) => {
        setSamePasswords(true);
        setPasswordRepeat(value);
        if(password !== passwordRepeat) setSamePasswords(false); else setSamePasswords(true);
    }

    return (
        <div className="modal-content">
            <FormGroup className="auth-modal-content">
                <h3>Сброс пароля</h3>
                <TextField label={"Новый пароль"} type="password"
                           onChange={(e: any) => isGood(e.target.value)}/>
                {password && <Val>
                    {Array.from({length: 4}).map((item, index) => {
                        return passed > index ? <PasswordPassedLine key={index}/> : <PasswordLine key={index}/>;
                    })}
                    {getPasswordText()}
                </Val>
                }
                <TextField label={"Повторите пароль"}
                           className="password-input"
                           type="password"
                           helperText={samePasswords? '' : 'Пароли не совпадают'}
                           error={!samePasswords}
                           onChange={(e) => comparePasswords(e.target.value)}
                           sx={{marginTop: '32px'}}/>

                <Button disabled={true} sx={{marginTop: '40px'}} variant="contained" className="blue-btn">
                    Сбросить пароль
                </Button>

            </FormGroup>
        </div>
    );
}

export default PasswordResetModal;
